module.exports = __webpack_public_path__ + "static/img/ROBERT-HANSEN-JR.3789fd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ROBERT-HANSEN-JR.jpg
// module id = geYf
// module chunks = 0